/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import RHFInput from 'src/components/elements/Input/RHFInput';
import { MdGridView, MdFormatListBulleted } from 'react-icons/md';
import DocsListView from '../DocsListView';
import DocsGridView from '../DocsGridView';
import { CandidateDocumentsViewRendererProps, DocumentResponse } from '../../types';

function DocsWrapper(props: CandidateDocumentsViewRendererProps) {
  const {
    documentList,
    loading,
    onDocumentDownload,
    onDocumentView,
    onOpenDocumentAddPopup,
  } = props;

  const [filteredDocs, setFilteredDocs] = useState<DocumentResponse[]>([]);
  const [isGridView, setIsGridView] = useState<boolean>(false);

  const methods = useForm<{ search: string }>();
  const { watch } = methods;
  const { search } = watch();

  const doSearch = () => {
    const copiedList = [...documentList];

    const list = search
      ? copiedList.filter((doc) => doc.documentName.toLowerCase().includes(search.toLowerCase()))
      : copiedList;

    setFilteredDocs(list);
  };

  useEffect(() => {
    doSearch();
  }, [search, documentList]);

  return (
    <FormProvider {...methods}>
      <form>
        <div className="flex flex-col w-full">
          <div className="w-full">
            <div className="w-full flex flex-row items-center justify-end mb-4 space-x-2">
              <div className="w-72">
                <RHFInput control={methods.control} name="search" placeholder="Search by name" />
              </div>
              <MdFormatListBulleted
                className={twMerge('h-7 w-7 cursor-pointer', !isGridView ? 'text-primary' : 'text-secondary')}
                onClick={() => {
                  setIsGridView(false);
                }}
              />
              <MdGridView
                className={twMerge('h-7 w-7 cursor-pointer', isGridView ? 'text-primary' : 'text-secondary')}
                onClick={() => {
                  setIsGridView(true);
                }}
              />
              <Button
                variant="contained"
                className="h-[40px] font-medium whitespace-nowrap"
                onClick={onOpenDocumentAddPopup}
              >
                Add Document
              </Button>
            </div>
            {isGridView ? (
              <DocsGridView
                documentList={filteredDocs}
                loading={loading}
                onDocumentDownload={onDocumentDownload}
                onDocumentView={onDocumentView}
              />
            ) : (
              <DocsListView
                documentList={filteredDocs}
                loading={loading}
                onDocumentDownload={onDocumentDownload}
                onDocumentView={onDocumentView}
                tableTitle="Documents"
              />
            )}
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default DocsWrapper;
